import React, { useEffect } from 'react';
import Typography from 'core/ui/Typography';
import { useTranslation } from 'react-i18next';
import { Dialog, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import Box from 'core/ui/Box';
import Texture from 'core/ui/Texture';
import { useDispatch, useSelector } from 'react-redux';
import { channelsActions, channelsSelectors } from 'modules/channels';
import { ButtonPrimary } from 'core/ui/Button';
import Paper from 'core/ui/Paper';
import { workoutsActions } from 'modules/workouts';

export default function ModalAddCoach({ close, onAddCoach = () => {}, workout, buttonColor }) {
  const { t } = useTranslation();
  const channelCoaches = useSelector((state) => channelsSelectors.getChannelCoaches(state));

  const dispatch = useDispatch();

  useEffect(() => {
    if (workout.channel) {
      dispatch(channelsActions.getChannelCoachesStart(workout.channel.id));
    }
  }, [dispatch, workout]);

  const addCoach = (userId) => {
    dispatch(
      workoutsActions.addWorkoutCoachStart(workout.id, userId, () => {
        onAddCoach();
        close();
      }),
    );
  };

  return (
    <Dialog open maxWidth="sm" fullWidth onClose={() => close()}>
      <Texture>
        <Box p={3}>
          <Typography mb={3} align="center" color="secondary" variant="h2">
            {t('workout.modal.addCoaches')}
          </Typography>

          <Paper p={3}>
            <TableContainer>
              <Table size="small">
                <TableBody>
                  {channelCoaches &&
                    channelCoaches
                      .filter((x) =>
                        ['admin_coach', 'coach_head', 'coach_owner', 'coach'].find(
                          (y) => y === x.accessType,
                        ),
                      )
                      .filter((x) => !workout.coaches.find((y) => y.id === x.user.id))
                      .map((coach) => (
                        <TableRow key={coach.id}>
                          <TableCell>{coach.user.name}</TableCell>
                          <TableCell align="right">
                            <ButtonPrimary
                              buttonColor={buttonColor}
                              onClick={() => addCoach(coach.user.id)}
                            >
                              {t('button.addCoach')}
                            </ButtonPrimary>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Texture>
    </Dialog>
  );
}

ModalAddCoach.propTypes = {};

ModalAddCoach.defaultProps = {};
